import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database';
import * as _ from "lodash";

@Component({
  selector: 'app-p0',
  templateUrl: './p0.component.html',
  styleUrls: ['./p0.component.css']
})
export class P0Component implements OnInit {

  public article: any = '';

  constructor(public db: AngularFireDatabase) { }

  ngOnInit() {

    this.db.object('/tw/article/about/p0').$ref.once('value').then(s => {
      this.article = s.val()['content'];
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/tw/about/p0/p0.component.ts